// extracted by mini-css-extract-plugin
export default {"primeDropdown":"PrimeDropdown_primeDropdown__Q3z1a","noBorder":"PrimeDropdown_noBorder__7qyfI"};